import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faPen, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

export function ListingGridActions({ disableEdit, disableDelete, onEdit, onDelete, onSettings, className = 'listing-grid-card__actions' }) {
  return (
    <div className={className}>
      {onSettings && (
        <button
          type="button"
          className="listing-action-btn listing-action-btn--settings"
          onClick={onSettings}
          title="Company settings"
        >
          <FontAwesomeIcon icon={faCog} />
          <span className="visually-hidden">Settings</span>
        </button>
      )}
      <button
        type="button"
        className="listing-action-btn listing-action-btn--edit"
        onClick={onEdit}
        disabled={disableEdit}
        title={disableEdit ? "You can't edit this" : "Edit"}
      >
        <FontAwesomeIcon icon={faPen} />
        <span className="visually-hidden">Edit</span>
      </button>
      <button
        type="button"
        className="listing-action-btn listing-action-btn--delete"
        onClick={onDelete}
        disabled={disableDelete}
        title={disableDelete ? "You can't delete this" : "Delete"}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
        <span className="visually-hidden">Delete</span>
      </button>
    </div>
  );
}
